import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@material-ui/core';
import React, { ReactElement } from 'react';
import styles from './styles';
import HeaderDialog from './HeaderDialog';
import CloseIcon from '@material-ui/icons/Close';

export interface IConfirmDialogProps {
  open: boolean;
  onClose: (reason) => void;
  onSubmit: () => void;
  title: string;
  body: ReactElement<any, any>;
}

const ConfirmDialog = ({
  open,
  onClose,
  onSubmit,
  title,
  body,
}: IConfirmDialogProps) => {
  const classes = styles();

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        onClose(reason);
      }}
      fullWidth
      className={classes.dialog}
    >
      <DialogTitle>
        <HeaderDialog titleKey={title} />
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{body}</DialogContent>
      <DialogActions>
        <Box width="100%" display="flex" justifyContent="flex-end">
          <div>
            <Button
              variant="outlined"
              className={classes.buttonStyle}
              onClick={onClose}
            >
              NO, BACK
            </Button>
            <Button
              variant="outlined"
              className={classes.buttonStyleBlack}
              style={{
                marginLeft: '5px',
              }}
              onClick={onSubmit}
            >
              YES, CONTINUE
            </Button>
          </div>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
